var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.608 11.057c.52.52.52 1.365 0 1.886L18.551 20l7.057 7.057a1.333 1.333 0 11-1.885 1.886l-8-8a1.333 1.333 0 010-1.886l8-8c.52-.52 1.364-.52 1.885 0z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNjA4MiAxMS4wNTcyQzI2LjEyODkgMTEuNTc3OSAyNi4xMjg5IDEyLjQyMjEgMjUuNjA4MiAxMi45NDI4TDE4LjU1MSAyMEwyNS42MDgyIDI3LjA1NzJDMjYuMTI4OSAyNy41Nzc5IDI2LjEyODkgMjguNDIyMSAyNS42MDgyIDI4Ljk0MjhDMjUuMDg3NSAyOS40NjM1IDI0LjI0MzMgMjkuNDYzNSAyMy43MjI2IDI4Ljk0MjhMMTUuNzIyNiAyMC45NDI4QzE1LjIwMTkgMjAuNDIyMSAxNS4yMDE5IDE5LjU3NzkgMTUuNzIyNiAxOS4wNTcyTDIzLjcyMjYgMTEuMDU3MkMyNC4yNDMzIDEwLjUzNjUgMjUuMDg3NSAxMC41MzY1IDI1LjYwODIgMTEuMDU3MloiIGZpbGw9IiNmZmYiLz4KPC9zdmc+";
export { SvgLeftArrow as ReactComponent };